module.exports = __webpack_public_path__ + "static/media/team_huddle_response.29f26ed0.png";